/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

// Components imports
import { Table } from 'antd';

// Misc imports
import { getCurrentQueryState } from '../../../store/utils/getCurrentQueryState';
import { useBotLanguage } from '../../../utils/hooks/useBotLanguage';

const ClassificationReportTable = ({ runTestSetResults }) => {
  const { t } = useTranslation();
  const { orgId, tenantId } = useParams();
  const { data: automatedAnswers, isFetching: isFetchingAutomatedAnswers } = getCurrentQueryState('fetchAutomatedAnswers', { orgId, tenantId });
  const { currentBotLanguage, primaryBotLanguage } = useBotLanguage();

  const columns = [
    {
      title: t('Automated Answer'),
      dataIndex: 'intentId',
      render: (_text, record) => {
        const matchedAnswer = automatedAnswers?.items?.find(answer => answer?.id === record.intentId) || null;
        return matchedAnswer?.name[currentBotLanguage] || matchedAnswer?.name[primaryBotLanguage] || record.intentId;
      },
      width: '30%'
    },
    {
      title: t('Precision'),
      dataIndex: 'precision',
      align: 'center'
    },
    {
      title: t('Recall'),
      dataIndex: 'recall',
      align: 'center'
    },
    {
      title: t('F1 Score'),
      dataIndex: 'f1Score',
      align: 'center'
    },
    {
      title: t('Support'),
      dataIndex: 'support',
      align: 'center'
    }
  ];

  return (
    <Table
      size="small"
      dataSource={runTestSetResults?.classificationReport}
      columns={columns}
      loading={isFetchingAutomatedAnswers}
      pagination={{
        size: 'default',
        showTotal: (total) => `${t('Total Reports')}: ${total}`
      }}
    />
  );
};

ClassificationReportTable.propTypes = {
  runTestSetResults: PropTypes.array
};

export default ClassificationReportTable;
